import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Image, ProgressBar } from '../AbstractElements';
import { dynamicImage } from '../Utils';
import { getData } from '../CommonElements/Functions/PostGetFun';
import { API } from '../api/API';
import {
    prepareDexieSchema,
    insertDataToDexie,
    ColumnDefinition,
} from '../db/DexieServises';
import { generateColumnsAndDataFromResponse } from '../db/AddGetData';
import Dexie from 'dexie';

const FirstLoader: React.FC = () => {
    const serverUrl = localStorage.getItem('serverUrl');
    const APP_TOKEN = localStorage.getItem('appToken');
    const navigate = useNavigate();

    const handleSubmitAPI = async () => {
        if (!serverUrl || !APP_TOKEN) {
            console.error('❌ Missing server URL or app token');
            return;
        }

        const url = `${serverUrl}${API.getMasters}`;
        const masterKeys = ['User','Employee', 'Position', 'OrgUnit', 'Branch', 'Grade', 'Designation', 'RolePerms'];
        const allSchemas: Record<string, ColumnDefinition[]> = {};
        const allRecords: Record<string, Record<string, any>[]> = {};

        // 🟢 Step 1: Fetch and prepare master data
        for (const key of masterKeys) {
            try {
                const { status, data } = await getData(url, true, { key });

                // console.log(data.data,status,'data.data=keys');
                if (status === 200 && Array.isArray(data?.data) && data.data.length > 0) {
                    const allColumnsSet: Map<string, ColumnDefinition> = new Map();
                    const recordsArray: Record<string, any>[] = [];
                    let idCounter = 1;

                    for (const item of data.data) {
                        const { columns, records } = generateColumnsAndDataFromResponse(item, idCounter);
                        idCounter += 1;

                        if (Array.isArray(columns)) {
                            for (const col of columns) {
                                allColumnsSet.set(col.name, col);
                            }
                        }

                        if (Array.isArray(records)) {
                            recordsArray.push(...records);
                        }
                    }

                    const finalColumns = Array.from(allColumnsSet.values());
                    allSchemas[key] = finalColumns;
                    allRecords[key] = recordsArray;

                    localStorage.setItem(`schema_${key}`, JSON.stringify(finalColumns));
                } else {
                    console.error(`❌ Failed to fetch or no data for ${key}`);
                }
            } catch (error) {
                console.error(`❌ Exception while fetching ${key}:`, error);
            }
        }



        // 🟢 Step 3: Prepare Dexie schema and insert all data
        console.log('🧩 Final Schemas Before Dexie Init:', Object.keys(allSchemas));
        console.log('🧩 Columns for RolePerms:', allSchemas['RolePerms']);

        if (!allSchemas['Employee']) {
            console.error('❌ Employee schema is missing. Skipping Employee table creation.');
        } else {
            console.log('✅ Employee schema found:', allSchemas['Employee']);
        }

        await Dexie.delete('DynamicDB');
        localStorage.removeItem('dexie_dynamic_version');
        localStorage.removeItem('dexie_schema_hash');

        localStorage.setItem('dexie_all_schema', JSON.stringify(allSchemas));
        await prepareDexieSchema(allSchemas); // 💡 forceVersionUpdate=true

        for (const key of Object.keys(allSchemas)) {
            const columns = allSchemas[key];
            const records = allRecords[key];

            if (Array.isArray(columns) && columns.length > 0 && Array.isArray(records)) {
                console.log(`📥 Inserting into ${key}:`, { columns, count: records.length });
                await insertDataToDexie(key, records);
            } else {
                console.warn(`⚠️ Skipping ${key} due to missing columns or records.`);
            }
        }


        console.log('✅ All master and session data inserted');
        navigate('/admin');
    };

    useEffect(() => {
        handleSubmitAPI();
        // console.log('loader compo trigger');

    }, []);

    return (
        <div className="page-body">
            <div className="default-dashboard">
                <div className="d-flex align-items-center justify-content-center profile-media">
                    <div>
                        <Image
                            className="b-r-10 img-80"
                            src={dynamicImage('dashboard/loader.gif')}
                            alt="Loading..."
                        />
                    </div>
                    <ProgressBar color="success" value={75} />
                </div>
            </div>
        </div>
    );
};

export default FirstLoader;
